module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMjU2IDhDMTE5IDggOCAxMTkgOCAyNTZzMTExIDI0OCAyNDggMjQ4IDI0OC0xMTEgMjQ4LTI0OFMzOTMgOCAyNTYgOHptNTcuMSAzNTAuMUwyMjQuOSAyOTRjLTMuMS0yLjMtNC45LTUuOS00LjktOS43VjExNmMwLTYuNiA1LjQtMTIgMTItMTJoNDhjNi42IDAgMTIgNS40IDEyIDEydjEzNy43bDYzLjUgNDYuMmM1LjQgMy45IDYuNSAxMS40IDIuNiAxNi44bC0yOC4yIDM4LjhjLTMuOSA1LjMtMTEuNCA2LjUtMTYuOCAyLjZ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/solid/clock.svg
// module id = GaMj
// module chunks = 1